import { alpha, Card, styled } from '@/shared/ui/mui';
/**
 * PlanCard - An enhanced card for displaying subscription plans or similar content
 *
 * Features:
 * - Full height display with flex column
 * - Rounded corners (20px)
 * - Smooth hover animation with significant lift
 * - Enhanced shadow on hover
 * - Perfect for pricing plans, feature comparisons, etc.
 *
 * Usage:
 * ```tsx
 * <PlanCard>
 *   <CardContent>
 *     {/* Your plan content *\/}
 *   </CardContent>
 * </PlanCard>
 * ```
 */
export const PlanCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  borderRadius: '20px',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  boxShadow: `0 10px 30px ${alpha(theme.palette.common.black, 0.08)}`,
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: `0 20px 40px ${alpha(theme.palette.common.black, 0.12)}`,
  },
}));
